import { useHasAccess } from 'lib-shared-access-control';
import { MetaConversation } from 'lib-shared-legacy-types';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import ContactCard from '../../cards/ContactCard';
import { ConversationCustomFieldsCard } from '../../cards/customFields';
import { HistoryCard } from '../../cards/historyCard/HistoryCard';
import { UserTrackingCard } from '../../cards/userTrackingCard';
import { CardSection } from '../cardSection/cardSection';

type CustomerInfoCardsProps = {
  index: number;
  metaConversation: MetaConversation;
  isMinimized: boolean;
  isCardOpen: (card: string) => boolean;
  toggleCard: (card: string) => void;
};

export const CustomerInfoCards = ({
  index,
  toggleCard,
  isCardOpen,
  isMinimized,
  metaConversation,
}: CustomerInfoCardsProps): JSX.Element => {
  const flags = useFeatureFlag([
    'collapse-tracking-card-core',
    'show-tracking-card',
  ]);
  const hasCustomAttributeAccess = useHasAccess(
    'conversation.custom_attribute',
  );

  return (
    <CardSection
      title={!isMinimized ? 'Customer Info' : undefined}
      index={index}
      isMinimized={isMinimized}
    >
      <ContactCard
        onToggle={() => toggleCard('contact')}
        isOpen={isCardOpen('contact')}
        isMinimized={isMinimized}
      />

      {hasCustomAttributeAccess && metaConversation.conversation.id && (
        <ConversationCustomFieldsCard
          csid={metaConversation.conversation.id}
          isMinimized={isMinimized}
          isOpen={isCardOpen('custom-fields')}
          onToggle={() => toggleCard('custom-fields')}
        />
      )}

      {metaConversation.requester &&
        metaConversation.previousConversations &&
        metaConversation.previousConversations?.length !== 0 && (
          <HistoryCard
            onToggle={() => toggleCard('history')}
            isOpen={isCardOpen('history')}
            previousConversations={metaConversation.previousConversations}
            requester={metaConversation.requester}
            isMinimized={isMinimized}
          />
        )}

      {flags.showTrackingCard && (
        <UserTrackingCard
          onToggle={() => toggleCard('tracking')}
          isOpen={isCardOpen('tracking')}
          attributes={metaConversation.conversation.attributes ?? {}}
          isMinimized={isMinimized}
          hasCollapseTrackingCard={flags.collapseTrackingCardCore}
        />
      )}
    </CardSection>
  );
};
